import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatDividerModule } from "@angular/material/divider";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { AggregatesModule } from "@tylertech/aggregates-module";
import { ChartJsContainerComponent } from "@tylertech/chart-js";
import { ChartingModule } from "@tylertech/charting-module";
import { CommandsModule } from "@tylertech/commands-module";
import { CommonComponentsModule } from "@tylertech/common-components-module";
import { CoreModule } from "@tylertech/core-module";
import { CustomViewModule } from "@tylertech/custom-view";
import { IntentsModule } from "@tylertech/intents-module";
import { LgdCurrencyModule, LgdTypeAheadModule } from "@tylertech/lgd-reactive-forms";
import { MetadataModule } from "@tylertech/metadata-module";
import { InvoiceApprovalActionHandler } from "./aggregateActionHandlers/invoiceApprovalActionHandler";
import { OutstandingInvoicesChartComponent, VendorHistoryChartComponent } from "./charts";
import { FundRecapRowComponent, FundTotalChartComponent, FundTotalDetailComponent } from "./fundTotalDetail";
import
{
    ApModuleControlService,
    BankCodeService,
    CheckStockService,
    CommodityCodeService,
    ContractService,
    FundTotalService,
    GroupCodeLookupService,
    InvoiceService,
    ItemDistributionService,
    PayableImportMetadataService,
    PayableImportService,
    PayableService,
    PaymentPrintBatchService,
    PaymentService,
    PurchaseCardService,
    SalesTaxCodeLookupService,
    ShipToLookupService,
    VendorAddressService,
    VendorClassLookupService,
    VendorContactService,
    VendorDirectDepositService,
    VendorInvoiceEntryService,
    VendorLookupService,
    VendorMergeService,
    VendorService,
    VendorSetLookupService,
    VendorTemplateLookupService
} from "./services";
import { VendorInvoiceEntryComponent } from "./vendorInvoiceEntry";

const angularModules = [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
];

const angularMaterialModules = [
    MatCardModule,
    MatDividerModule,
    MatProgressBarModule,
];
const lgdModules = [
    CommandsModule,
    CommonComponentsModule,
    CoreModule,
    IntentsModule,
    ChartingModule,
    ChartJsContainerComponent,
    CustomViewModule
        .withComponents(
            /* eslint-disable @typescript-eslint/naming-convention */
            {
                "accounts-payable-outstanding-invoices-chart": OutstandingInvoicesChartComponent,
                "accounts-payable-vendor-history-chart": VendorHistoryChartComponent,
                "fund-total-detail": FundTotalDetailComponent
            }
            /* eslint-enable @typescript-eslint/naming-convention */
        ),
    AggregatesModule.withActionHandlers(
        InvoiceApprovalActionHandler),
    MetadataModule,
    LgdTypeAheadModule,
    LgdCurrencyModule
];

const components = [
    VendorInvoiceEntryComponent,
    FundRecapRowComponent,
    FundTotalChartComponent,
    FundTotalDetailComponent,
    VendorHistoryChartComponent,
    OutstandingInvoicesChartComponent,
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules,
    ],
    declarations: components,
    exports: components,
    providers: [
        VendorTemplateLookupService,
        VendorDirectDepositService,
        GroupCodeLookupService,
        ContractService,
        ItemDistributionService,
        FundTotalService,
        PayableImportMetadataService,
        PurchaseCardService,
        VendorMergeService,
        VendorLookupService,
        VendorSetLookupService,
        VendorService,
        VendorContactService,
        VendorClassLookupService,
        ShipToLookupService,
        SalesTaxCodeLookupService,
        PaymentPrintBatchService,
        PaymentService,
        InvoiceService,
        PayableService,
        PayableImportService,
        ApModuleControlService,
        InvoiceApprovalActionHandler,
        VendorInvoiceEntryService,
        VendorAddressService,
        CommodityCodeService,
        CheckStockService,
        BankCodeService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccountsPayableModule
{ }
